// VideoDisp.js - หน้าจอแสดงวิดีโอและคำถาม
// หน้าที่: แสดงวิดีโอ YouTube และจัดการการตอบคำถามของผู้ใช้
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import YouTube from 'react-youtube';
import { db } from '../Firebase';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import './VideoDisp.css';
// นำเข้าไฟล์เสียงต่างๆ
import countdownSound1 from './assets/countdown1.mp3';
import countdownSound2 from './assets/countdown2.mp3';
import countdownSound3 from './assets/countdown3.mp3';
import correctSound from './assets/true.wav';
import wrongSound from './assets/wrong.wav';

// รายการวิดีโอสำหรับระดับ Silver (ระดับ 1)
const SILVER_VIDEO_LIST = [
  "4hZxuQFykic", "fTdHY0Gp9BQ", "8Qjov3IuwZs", "z94TzJBX9wE", "2xqR6V_EdyQ", "gkET_h4rrzI", "S0vHoLuAsOQ", "Mt--o_aXsRY", "FqXj35Ne1oo", "Ub07thWQGuw",
  "tpSz0KcyCrI", "3Qm57OvDf8k", "mXNLaQWTmKU", "IBkRh1br_5o", "KcGeCJmlx5w", "xxmqVwtxYGA", "5vfigiMjndk", "YSiQmpQirgE", "CtaCel9HoiA", "X1RF8fm8vbA",
  "K7LGDxmG1j4", "yuDbWC0dmlg", "foCcXYtYdYQ", "VbEvWj9FkX8", "oMDNe5qMS4A", "zBX5cifxdxU", "NoqdU8WxpPM", "PwzMw6MWM5k", "2NYTsq9eguU", "gzoK0Pp-UM0",
  "WHexkELt95Y", "8YdbCi0o_p4", "mRW4H8TwzlQ", "VSgkeFbXdj0", "iQ2_Nk7BANM", "TRX3hMI9DwQ", "xPOp4oDrPnY", "fDkpJ5CcNWw", "MUaMVJNm3v4", "WoYojHt_ehc",
  "cznP-DP6ppg", "rYGcpX2VFbQ", "uYYYDq13Ygo", "501NzeIIi-I", "7GFWNdar5-w", "CMKLTjVcJQY", "NTpMYBls5nA", "nZ2Gl6IXJ3Q", "GkGa1VwcNCc", "gdabaZ49knI",
  "P0SphTK4P1w", "hC0rNMPagog", "8tpcrfhA3bg", "ETECno8CqT4", "FSv-7fxmRJk", "IO90T-5lyYo", "mdTVzwdb7O4", "hCOO2ix7-sU", "B2gtN0kwA6M", "-fX5SMAreZY",
  "tqmYNozLJ2E", "zB813L2HIkQ", "kupqo0EhPDw", "u5dk8b3hTOU", "kzblreOHp2c", "1jaUmRRFJ7Y", "l7ShUsZl_jA", "M-OgSxwvANs", "4aOh4axB1-o", "bHaPnJNqKJY",
  "aH11D0hVqf8", "Lhqn3B1-sAU", "jsgkHbln8vI", "FczFbKlZ3Fk", "AK0XRDBoZCA", "Ngqu6RPMK_I", "szCE7E8CK58", "l--1I1jQ6qc", "CUrZOpCa5I8", "uwxoaJ7z9bc",
  "gAMOAXH0Rkw", "F_spEsmOtZE", "zKtMulErKA8", "efCVome8gUU", "YzRBJ3uxAro", "KXurI9Yoo2E", "_hja2ffE_70", "wqrflOGJCMw", "zaa6SPXKLbs", "FbQ3_2iY-FI",
  "dvHHK5TFitg", "pK4f8Dae7fs", "GBfE3Blm9sQ", "-kV-2Si1IrE", "_mdTByN1QhI", "2OuHydJr4g8", "MuD9RWbc9WU", "1xvXtNLQ0YA", "9UONigS5Suc", "LtuDTT3fRd4",
  "gj1oF_j4H5U", "cOWnKJve0Xw", "5KBBwXQzJUM", "RX-8twHnt_4", "iRP7T4KQNb0", "daSt2ztKziM", "rZkhHlf6KrI", "BF1JaTuNX-E", "HTFKh5oYjdU", "6sgu8X9BoYQ",
  "jQ4NL-PoPrc", "60CE4vuMNNo", "GeDh1dxU0Mg", "3ljIsDpvWHw", "3VMy8kIVjFc", "oH538234T2E", "L7V_kL2Uc68", "FIGFX9VPNSQ", "Pbf0TY-zsJk", "S2iyAZLLwNI",
  "e-plsTidGaI", "oWNXpJXgr8I", "iVC5e2NE5ok", "VAPAA8FNiwA", "wKZPbMlB62k", "UvHpEot17ks", "JGOmo6pbeo8", "PGMCl_Ip42A", "o4u1Djb2KeI", "j27vlNwmusE",
  "ZJKTOgbaqxU", "HuOyu5GTMjc", "FsDwOvSOPOk", "OIidgRDrBMU", "3CucvHlI9PM", "n8B-r-q_oqs", "z5fGJoJEs_0", "4rfIjRjITkk", "AvxpkaoW8N4", "KwsskUeA0SE",
  "uQt4kad6GT4", "c0OLTwIcz_M", "-njO0L_N12U", "2dp0ptw3Wbw", "vcVSASee9HQ", "Vr6LhXm9RUY", "i8rC2bYtZXw", "zEJSJ4OlWS8", "h6T7sXjsTi4", "vq9qm4TZFLc",
  "xwsu0mlKiMQ", "d3N3tpQAWNw", "AeSKqhfyFKw", "vzUsYqKX3mI", "FBzQcrbnBSg", "Wx5SWGF1V28", "9PAlfMlw5tk", "Qyl_eqNn6Uc", "QSuNYveH1bg", "QdFL8y1D5YA",
  "VfD0Dd5-cdo", "qdNsF-R7WbY", "bbNpIDLvWY4", "c4X9xZF8LPk", "8zKzdMCHeiA", "UL5oMM7MKBo", "omPzj8pIiDA", "fb7xkdO8Wtw", "yw6-5hZUIC4", "Yw784iluPFE",
  "yeJjdRt3wNE", "RgcyaOW7id0", "moqqa9vGpno", "ifSjQaxYD7Y", "Edt09v5IVOE", "l8EhJjtLi0A", "52d-rUeAG8M", "QN0k2agIeGc", "EQFtPv_gkTI", "5ZoaV6iknnk",
  "yAz2ZOQzCk8", "OZ2aE-anQmw", "2fdXC3s2BsM", "KEmmsHC75DM", "ENG0PAKufX8", "zhrbec_n3vY", "LOMsXxM_Xck", "LVq_QLCodx4", "6ZarOqTiXJ4", "-c3uG136KPo",
  "MtOKIHK9hg4", "VNnYrgFdmeA", "rlxLa63sAjw", "aRPqjKsvPJk", "ym-w9QQE2GE", "G8t_W0EEq00", "iazhDgoLLAw", "T2kJOYE0F3o", "_Bl6n7TkBfM", "Y24ZVnQy-ds"
];
// คำตอบที่ถูกต้องสำหรับระดับ Silver (ระดับ 1)
const SILVER_CORRECT_ANSWERS = {
  0: "69",  1: "98",  2: "79",  3: "81",  4: "68",  5: "77",  6: "19",  7: "11",  8: "97",  9: "13",
  10: "99", 11: "15", 12: "77", 13: "51", 14: "77", 15: "79", 16: "99", 17: "76", 18: "57", 19: "20",
  20: "30", 21: "59", 22: "67", 23: "99", 24: "21", 25: "95", 26: "55", 27: "98", 28: "97", 29: "67",
  30: "99", 31: "93", 32: "98", 33: "76", 34: "49", 35: "79", 36: "13", 37: "41", 38: "94", 39: "10",
  40: "99", 41: "94", 42: "59", 43: "57", 44: "95", 45: "10", 46: "67", 47: "76", 48: "52", 49: "94",
  50: "89", 51: "28", 52: "97", 53: "10", 54: "24", 55: "52", 56: "32", 57: "54", 58: "10", 59: "11",
  60: "65", 61: "22", 62: "52", 63: "69", 64: "29", 65: "49", 66: "94", 67: "25", 68: "44", 69: "98",
  70: "18", 71: "32", 72: "58", 73: "51", 74: "50", 75: "66", 76: "60", 77: "79", 78: "32", 79: "22",
  80: "99", 81: "49", 82: "79", 83: "11", 84: "79", 85: "14", 86: "90", 87: "20", 88: "88", 89: "79",
  90: "11", 91: "10", 92: "51", 93: "27", 94: "49", 95: "99", 96: "11", 97: "25", 98: "60", 99: "22",
  100: "12", 101: "20", 102: "87", 103: "26", 104: "34", 105: "35", 106: "68", 107: "91", 108: "21", 109: "84",
  110: "15", 111: "20", 112: "90", 113: "20", 114: "79", 115: "23", 116: "93", 117: "29", 118: "36", 119: "88",
  120: "79", 121: "45", 122: "79", 123: "89", 124: "97", 125: "11", 126: "96", 127: "39", 128: "1", 129: "33",
  130: "48", 131: "11", 132: "88", 133: "15", 134: "87", 135: "25", 136: "87", 137: "65", 138: "97", 139: "49",
  140: "15", 141: "52", 142: "20", 143: "39", 144: "22", 145: "11", 146: "49", 147: "21", 148: "21", 149: "12",
  150: "81", 151: "79", 152: "46", 153: "98", 154: "34", 155: "69", 156: "41", 157: "69", 158: "44", 159: "94",
  160: "73", 161: "89", 162: "90", 163: "19", 164: "20", 165: "59", 166: "47", 167: "79", 168: "78", 169: "17",
  170: "79", 171: "23", 172: "93", 173: "25", 174: "87", 175: "65", 176: "20", 177: "88", 178: "79", 179: "88",
  180: "17", 181: "38", 182: "60", 183: "42", 184: "11", 185: "81", 186: "21", 187: "39", 188: "1", 189: "54",
  190: "87", 191: "26", 192: "34", 193: "22", 194: "11", 195: "49", 196: "22", 197: "12", 198: "20", 199: "99"

};

// รายการวิดีโอสำหรับระดับ Gold (ระดับ 2)
const GOLD_VIDEO_LIST = [
"NeaXK2Ub5fg", "Oj8Yr4O2t5A", "RTuqJPM2ZBY", "zQD1jl80nGs", "S3qQN7ZBbcs", "Her3fdEgvys", "xVrgEARXJ0g", "z1BwcvL72aE", "xUNijNY7vY0", "J4KxchpJGeo",
"9lnGHlHRTFA", "zel6pzCG_Mk", "WPBHzG6oPsA", "1Vv0fUOmf50", "3lY26trCpww", "9TG8zGaInz8", "pIqJPl1msKk", "HImlwoGcYO0", "8lWQYQdkaeQ", "OdgcMkgObOY",
"Yp8LACzyVI0", "23fsyuDODb8", "rhikypnw1n0", "ssPLgcRhmeU", "rjjdUFbiSO4", "ot1EMOHW8qI", "hxU_7O179UU", "FjR17jlUwp8", "zmPXrSkszPQ", "BVXcVtPyqZs",
"lbC4IEjSaoI", "snvmTCTNRes", "9gjGr920-4k", "Z-xOdGbKBjs", "ubmN7AFuW8g", "fh4Gr7zmOYA", "5aWnZFzqPc0", "By8rGg_Mr1Q", "49NiArTRlUU", "A2UjWwX6t7s", 
"fkCe0yrwHb8", "cv7gaC4s3XM", "SxIN-fAatdc", "huScZiXjnwg", "iVgvHkIgaWg", "omcVQ8E2M2k", "oPuemYVnEyk", "upgPw-bjXNM", "_iyGpTJK9kI", "N3IW8csoS7M",
"ql4kKFyJOL4", "0G2_Ok-aHFw", "k-OVNNs_0l4", "ogdqEQJVKl0", "vRkTlWfb2Vk", "b7XrqYNLo1Q", "Vp6on4tspQ8", "R99buyv0I5A", "lvL0n_nkGYI", "SJ0kao6JsOE", 
"2M_ewyyh-70", "7_RtMIvbAn0", "lqyoeERjJbo", "6wsFxuzsKww", "5tpKhLUkU8Q", "aN4INDI2oxs", "neHeTCZElyE", "KlQR-G6joLk", "wM5gbRYllvQ", "3W7T0twiScg", 
"cfu-g8BL0Mg", "-BbCaoy9zVs", "CfoMLLG5-VU", "CR8OVKnM6Gc", "VJmOKtwq7nE", "H34OR1FU6L8", "d_SzWsNd0Zs", "W-9lyf1rPZ8", "1E_wxWs3iDM", "TxzgZAfRtoc", 
"f05W5Zd7YWk", "C2jsP-robzs", "Rq9F4YXR61U", "ooUKl3DWzFY", "RPnreBDTt1Q", "ZR6y7fBVI6o", "DaZEi0o2wZ8", "MoEGSLXVzJY", "F_NTRF1rLIM", "jo1FUgrvKxs", 
"WTzE2sgk24A", "aREASkCuKj0", "-QfQR_iDd0s", "p4QEtUlgu40", "fjBX6h4Fcas", "OE3FdOGt-8k", "R4MvjoottD0", "790nXWDZiDM", "dRN96lbP7mQ", "65CrhLz_S2Y", 
"2W_8vGLyXrY", "yN4BRrFwUIc", "RcXemNcFDTQ", "lh0TG2qcB_A", "yoTIa-FZEuA", "SS_rbi3iKFo", "jYfcDOneR9c", "P6EHc9yU4Nw", "ykiCY1l1zn4", "5dKq7ahxXFI",
"WPuPAqzfHjk", "AwZLe2XcKA8", "sIS8HBPc3T4", "GAxWDe1SeA4", "ltXNS1xDkts", "lTVIgQQiiu4", "oG_TRPuTOFI", "jnexaYUrzZs", "SiS7IiqQr9Q", "-GJF4ttwmeg",
"p9bdbMpMU9Q", "eKVCNSfhzRo", "2mOaBrJL__0", "QQGWl2377Fk", "au2OOhPUM7o", "GsvRCrlGiiQ", "r5VM0fyVznU", "-RxLBPTBMFY", "dziQpUQcawQ", "kwpppKEAiUg",
"vsQj9JE1J18", "NsXj2_Xpw6Q", "NYxc_kRzklI", "kDrUKOxjkYI", "b8KFyYLfEvc", "4mCOdz7X8aA", "rw1vHhmmjoA", "6gKi4mBZf8I", "6AfBa17pAF4", "vB_yCjy_kw4", 
"17kjKsFgbYQ", "j5F22RCmUHs", "NHJ5s29im3U", "vZcbwZBzEqA", "682OdglA_dA", "4NV2uWc4g7Y", "ZgOjd-CnTLw", "b3Nrkh1dXBU", "3aqlDyuvYTE", "GQ5eCSzRIss", 
"prq7LxTnJW4", "J8XujByttqw", "e1kCmy5WeKI", "jJR3DBMO5JI", "SI8-2cWBcfw", "H_tf92jgZwo", "I72T63CrpY0", "q73ThcQ0qZA", "4pu8h5rc8BA", "7umYaCvGuB0", 
"ArNSGiBTOik", "lOWYtsoR5hc", "uvxWMcl3xPc", "lvL0n_nkGYI", "m0h437xxu2c", "wA3-nGcBsjw", "_YN4qQp29hY", "8GLPcIks0v4", "UhHrJEpEtMw", "5lDL22gJer0", 
"bcaHAB1d8MI", "kD5f5C4mvms", "QjJFvf8cpmI", "FrMs1WSwgpE", "Uuz_cw48-8U", "VPm4-2_nGUU", "rL8waFtj4PI", "YEWXaKKX7vU", "mj7biwb9Dbo", "Ui-gfTm7CJ4", 
"RJcJHez9bgY", "1ioK_4atARM", "8BSoWiOf8UQ", "YtHOPscZ6tc", "ppXu3CvzMYk", "K12527wFtlc", "j4XU-WoVjtg", "K7iPRhlf1pc", "0e2kAK1KjEk", "CGoSPX_LB20", 
"OAhhs7xvPlo", "rJ1bfFUM8go", "jWHrmTWSuW8", "zQSqry3nATA", "yPjZxmUeonI", "XsBuoxO0aJ4", "yep9crhnPEc", "GGqFg2HBMGE", "_6BCyyvuwVc", "u5aZHDywnS0"

];
// คำตอบที่ถูกต้องสำหรับระดับ Gold (ระดับ 2)
const GOLD_CORRECT_ANSWERS = {
  0: "24",  1: "29",  2: "43",  3: "22",  4: "27",  5: "44",  6: "31",  7: "67",  8: "64",  9: "52",
  10: "67", 11: "83", 12: "56", 13: "65", 14: "66", 15: "39", 16: "74", 17: "99", 18: "78", 19: "52",
  20: "20", 21: "48", 22: "83", 23: "78", 24: "25", 25: "11", 26: "96", 27: "78", 28: "52", 29: "20",
  30: "48", 31: "83", 32: "78", 33: "25", 34: "11", 35: "96", 36: "55", 37: "96", 38: "74", 39: "25",
  40: "18", 41: "47", 42: "52", 43: "52", 44: "50", 45: "99", 46: "11", 47: "21", 48: "88", 49: "25",
  50: "89", 51: "3", 52: "14", 53: "48", 54: "13", 55: "62", 56: "47", 57: "54", 58: "10", 59: "12",
  60: "14", 61: "71", 62: "98", 63: "78", 64: "62", 65: "31", 66: "43", 67: "12", 68: "50", 69: "89",
  70: "55", 71: "32", 72: "50", 73: "44", 74: "60", 75: "56", 76: "99", 77: "78", 78: "89", 79: "55",
  80: "39", 81: "78", 82: "70", 83: "55", 84: "51", 85: "98", 86: "89", 87: "49", 88: "31", 89: "45",
  90: "49", 91: "61", 92: "98", 93: "25", 94: "60", 95: "77", 96: "87", 97: "50", 98: "71", 99: "32",
  100: "89", 101: "59", 102: "49", 103: "15", 104: "89", 105: "49", 106: "24", 107: "97", 108: "19", 109: "49",
  110: "20", 111: "89", 112: "10", 113: "78", 114: "31", 115: "37", 116: "20", 117: "92", 118: "21", 119: "88",
  120: "36", 121: "89", 122: "54", 123: "93", 124: "13", 125: "51", 126: "89", 127: "41", 128: "39", 129: "98",
  130: "61", 131: "76", 132: "55", 133: "30", 134: "24", 135: "77", 136: "49", 137: "40", 138: "78", 139: "99",
  140: "37", 141: "77", 142: "63", 143: "48", 144: "26", 145: "50", 146: "51", 147: "77", 148: "86", 149: "84",
  150: "94", 151: "77", 152: "52", 153: "71", 154: "69", 155: "97", 156: "27", 157: "5", 158: "69", 159: "69",
  160: "53", 161: "89", 162: "64", 163: "22", 164: "48", 165: "60", 166: "16", 167: "50", 168: "18", 169: "19",
  170: "51", 171: "22", 172: "25", 173: "88", 174: "97", 175: "90", 176: "22", 177: "23", 178: "61", 179: "37",
  180: "52", 181: "20", 182: "51", 183: "98", 184: "96", 185: "78", 186: "79", 187: "2", 188: "5", 189: "78",
  190: "75", 191: "79", 192: "59", 193: "97", 194: "11", 195: "36", 196: "99", 197: "94", 198: "25", 199: "53"

};

// รายการวิดีโอสำหรับระดับ Diamond (ระดับ 3)
const DIAMOND_VIDEO_LIST = [
  "aS-dvZYRMP4", "7QeBQ6fjC3s", "-2q0QLg2_IM", "qPlOt31XuLo", "_DLXuNDjHf4", "LWuDN1t73Ds", "mMtK4f__R7E", "em1ScyNigGc", "3dLpCg-J5Kw", "rJuVRXqJkMY",
  "-cfEebZdvf4", "J6-jM9VcccY", "LgxOxVN5eu0", "-EGQelHZSuI", "rMwE2NylEjA", "RtC30P-Gp3A", "ABLytpw_Omg", "Bp3q-vzR5eM", "4dTRIim6HJU", "HMa1GSSqB4s",
  "sFMti7yxnOk", "e9E9BnnnGQQ", "cwRPCfvvBlo", "TTAZz5ugNn0", "0HTb4PxaVZ4", "qFyCLHveKOA", "agXfHNS_WZw", "C_1aEhyuI_g", "_EUyTgihhVk", "U_AQW01OXCQ",
  "1YS9i7NxyE0", "e4pvTAa6TH4", "_Fly8KRSaOA", "Z6tYzm6YbGE", "oBPFlfQrQS4", "MCiJB1w0GJs", "LiWqxGiYUmA", "AdZ3x84trKQ", "iSqUbtKLHJI", "QVK21ddpDK8",
  "XkN2K9fAaEc", "HBz4GvljgfM", "Hd-kC9vT6T4", "8VTkiOa4kuU", "PTwmpJCrxUM", "1xEsSmHnUvY", "G7pUFRQD2bs", "gWQVOfeCfAU", "KrWqiCLTdIE", "SeH_udbp5jI", 
  "gWAmpLFnh8k", "XP05Tes7vEI", "TzCYksYhbRg", "9wVrrpnG5g4", "i4zDeTZ56YQ", "NgWntAq78hQ", "9GsiHj_gV-8", "KG6YxDLI3aQ", "XYBoXp4kENs", "DRD1fPbpKOo",
  "7bQHdM-KP6I", "9deWksdibEU", "Y0XxdV244sg", "-OHWbvgLYrQ", "nXbAdv3ikz4", "GmkM4QFloPA", "bT1BSjgnzWI", "LcZvWi3vCbM", "hfMCnD9N5f8", "ihtgM7xdmb0",
  "ZNGdKF9tUKM", "r2tKjPBka84", "lRjWSTAz9tU", "LfQ4sju-qR4", "PtO2GQtgPLU", "yTzc7tGFQiM", "l4wNARot50g", "7JjBykk_nZk", "a41zYtLLY_k", "73r5r7ZR3cI",
  "XB7QgTAoXFo", "wZU4BuTIBGU", "eBkOw5gVWdE", "cXcAxF_Poa0", "mVCfA-1YxO0", "b3_uoo_Thqc", "vNX4_H6YcoM", "vQvO90t9JgM", "qmE8FT8Iexk", "SoOHCuymwI0",
  "ZrE4usKlHp0", "NBhyd_C5BGY", "bAu_qaV0BCg", "vHW-CdPM7cE", "3GyHaz1JdfQ", "wWhZmTbvvyw", "V7ID711idu0", "ANv5TrHwPN8", "CRHrNO5fD-s", "Wc77ONlXDZk",
  "epgnh0qogzU", "K66tIGA5yGw", "PlEl0LDjSCA", "iEA1YbFWqiM", "_Q_YSI7vE0E", "tuz7698zNL8", "iAd6Jz4jMFQ", "SGBvrcMKn-0", "IguZgZCSxCs", "6z9JHHvkr3U",
  "oi1wk2zPAKU", "3TVYBYY9DjI", "yeQA0T54BAM", "wFXrQLmXbyE", "XB-mzGAJQH8", "yobk5zeNqos", "NqgyQCLr4zw", "ABY3-YO4lxY", "xWr6BRgaZPA", "OOwkyWkFkPA",
  "jvyMXc28yHM", "d9Li7Eh__84", "6Lj0zLnerw4", "CYBtbsATVxo", "NrbeIh3O_zc", "nDNi9Nqrldo", "w2ViusTXsmg", "Njf9UKSPa2I", "mBczusVFf9I", "M7H7c5oL2sc",
  "nAuSOggWho8", "WVrOU-lXBzg", "8mWM7T5g43s", "l6Kpqa1rRuo", "gDR2Agpd4AM", "46NOjHjVMDs", "6eP9QHnZizE", "4MvQaefMffs", "sNiobqGqYc4", "0s_l51ZabTc",
  "X-ulIV7FFR8", "wgZQYoUTtow", "-B9fJ9cSPlQ", "TOiSRugXrb8", "ylYAK0EE4JE", "Xrw0e2U-Wrc", "UV_zMJl0XF4", "rm4Bpvl924E", "jD6KiI5rkTE", "NLIQmnNDI-E",
  "2KjywBoIajk", "QROWyv6eQfU", "zK5SHBBPwps", "KPt7zgvlUx8", "y5LbLr56RvA", "wZXw-rgFpFE", "ZDrlSIjzVak", "Yk3BU76i2Cc", "cg3_ZyVoV98", "o_arfuZwoNU",
  "_-yzHbrHr8o", "I2ggZOZnFMk", "PKN4TJqlLqI", "J4MaP5sFe-s", "QtLcPmxBDWM", "gEG7gKmZ6Y4", "_wgTk2hqF_k", "Tnx-YxsWGM0", "yZx6laGytgc", "fp8zm8X0u80",
  "2Q_ueWyFT5g", "_Xlnmri5u2E", "bmITeKXSOWQ", "mxyRxc0846k", "g_mOo6YlUiw", "YDMdhUoqmt0", "HdUJCLQUt0A", "5qEXUGQ7kb8", "1GpOkSiD_nI", "Obw03ofJdxI",
  "KRe7PE2sf0M", "FCY9pfW2vMg", "d8p5NEMETt4", "Vqrrq902O9A", "6Doz6CITfMo", "9b3FLccEsrM", "AKfByPH9eJU", "CjemncAT1HI", "JmhJt-e_j4U", "TVTzlijrgp8",
  "3GTkWdl5zNk", "QXsJ7rpX50s", "D7HehK19Lz8", "Ar0bZmHNJ6o", "zSqBHvmKGrY", "l2dg7wUeuUY", "63lYNGeeuZ4", "VANPQlJCvPo", "Nfe9578vfsw", "GycsOOoMOZM"

  ];
  // คำตอบที่ถูกต้องสำหรับระดับ Diamond (ระดับ 3)
  const DIAMOND_CORRECT_ANSWERS = {
    0: "69",  1: "98",  2: "79",  3: "81",  4: "68",  5: "77",  6: "19",  7: "11",  8: "97",  9: "13",
    10: "99", 11: "15", 12: "77", 13: "51", 14: "77", 15: "79", 16: "99", 17: "76", 18: "57", 19: "20",
    20: "30", 21: "59", 22: "67", 23: "99", 24: "21", 25: "95", 26: "55", 27: "98", 28: "97", 29: "67",
    30: "99", 31: "93", 32: "98", 33: "76", 34: "49", 35: "79", 36: "13", 37: "41", 38: "94", 39: "10",
    40: "11", 41: "16", 42: "38", 43: "21", 44: "11", 45: "22", 46: "45", 47: "21", 48: "94", 49: "90",
    
    50: "6", 51: "98", 52: "4", 53: "29", 54: "82", 55: "31", 56: "99", 57: "98", 58: "67", 59: "71",
    60: "84", 61: "20", 62: "81", 63: "24", 64: "33", 65: "63", 66: "57", 67: "87", 68: "10", 69: "19",
    70: "67", 71: "20", 72: "71", 73: "20", 74: "37", 75: "19", 76: "11", 77: "71", 78: "40", 79: "59",
    80: "42", 81: "44", 82: "23", 83: "52", 84: "43", 85: "97", 86: "10", 87: "10", 88: "29", 89: "40",
    90: "99", 91: "89", 92: "40", 93: "43", 94: "62", 95: "10", 96: "42", 97: "25", 98: "51", 99: "65",
    100: "11", 101: "25", 102: "60", 103: "69", 104: "11", 105: "90", 106: "64", 107: "97", 108: "52", 109: "20",
    110: "14", 111: "38", 112: "59", 113: "92", 114: "68", 115: "85", 116: "45", 117: "42", 118: "31", 119: "13",
    120: "14", 121: "57", 122: "85", 123: "93", 124: "29", 125: "41", 126: "19", 127: "81", 128: "90", 129: "19",
    130: "19", 131: "40", 132: "86", 133: "97", 134: "59", 135: "79", 136: "81", 137: "45", 138: "59", 139: "29",
    140: "90", 141: "42", 142: "19", 143: "91", 144: "35", 145: "40", 146: "90", 147: "59", 148: "58", 149: "59",
    150: "16", 151: "59", 152: "41", 153: "12", 154: "73", 155: "63", 156: "13", 157: "70", 158: "95", 159: "11",
    160: "3", 161: "53", 162: "29", 163: "85", 164: "30", 165: "97", 166: "83", 167: "44", 168: "96", 169: "33",
    170: "52", 171: "84", 172: "53", 173: "36", 174: "85", 175: "79", 176: "7", 177: "5", 178: "96", 179: "73",
    180: "9", 181: "81", 182: "15", 183: "44", 184: "24", 185: "15", 186: "44", 187: "18", 188: "93", 189: "36",
    190: "85", 191: "69", 192: "8", 193: "14", 194: "19", 195: "14", 196: "32", 197: "4", 198: "94", 199: "11"

  };


// ฟังก์ชันคำนวณคะแนนตามเวลาที่เหลือและระดับ
const calculateScoreBasedOnTime = (timeRemainingSeconds, duration, currentState) => {
  const tier = timeRemainingSeconds / duration;
  
  // คะแนนเต็มตามระดับ
  let maxScore;
  if (currentState === 3) {
    maxScore = 30; // Diamond - คะแนนสูงสุด
  } else if (currentState === 2) {
    maxScore = 20; // Gold - คะแนนปานกลาง
  } else {
    maxScore = 10;  // Silver - คะแนนพื้นฐาน
  }
  
  return Math.round(tier * maxScore);
};

// ฟังก์ชันหลักของคอมโพเนนต์ VideoDisp
function VideoDisp({ userData, onUserUpdate }) {
  // ใช้ React hooks สำหรับการนำทางและสถานที่
  const navigate = useNavigate();
  const location = useLocation();
  
  // ใช้ useRef สำหรับเก็บข้อมูลที่ต้องอ้างอิง
  const playerRef = useRef(null); // อ้างอิง YouTube player
  const videoTimerRef = useRef(null); // timer สำหรับวิดีโอ
  const timerIntervalRef = useRef(null); // timer สำหรับการนับถอยหลัง
  const videoEndedRef = useRef(false); // สถานะวิดีโอจบแล้ว
  const levelTempUpdatedRef = useRef(false); // flag เพื่อป้องกันการอัปเดต Level-Temp ซ้ำซ้อน
  const levelMeterUpdatedRef = useRef(false); // flag เพื่อป้องกันการอัปเดต Level-Meter ซ้ำซ้อน
  
  // state สำหรับเก็บระดับปัจจุบัน (1=Silver, 2=Gold, 3=Diamond)
  const [currentState, setCurrentState] = useState(1);

  // โหลดระดับปัจจุบันจากฐานข้อมูลเมื่อคอมโพเนนต์เริ่มต้น
  useEffect(() => {
    const loadCurrentState = async () => {
      try {
        if (!userData?.username) return;
        const userRef = doc(db, "Competition-Training", userData.username);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const dbCurrentState = data['current-state'] || 1;
          setCurrentState(dbCurrentState);
        } else {
          setCurrentState(1); // เริ่มต้นที่ระดับ Silver
        }
      } catch (error) {
        console.error("Error fetching current-state:", error);
        setCurrentState(1); // เริ่มต้นที่ระดับ Silver เมื่อเกิดข้อผิดพลาด
      }
    };
    loadCurrentState();
  }, [userData?.username]);

  // เลือกรายการวิดีโอและคำตอบตามระดับปัจจุบัน
  const VIDEO_LIST = currentState === 3
    ? DIAMOND_VIDEO_LIST  // ระดับ Diamond
    : currentState === 2
      ? GOLD_VIDEO_LIST   // ระดับ Gold
      : SILVER_VIDEO_LIST; // ระดับ Silver

  const CORRECT_ANSWERS = currentState === 3
    ? DIAMOND_CORRECT_ANSWERS  // คำตอบระดับ Diamond
    : currentState === 2
      ? GOLD_CORRECT_ANSWERS   // คำตอบระดับ Gold
      : SILVER_CORRECT_ANSWERS; // คำตอบระดับ Silver

  // กำหนดระดับและวิดีโอที่จะแสดง
  const level = location.state?.level ?? userData?.['Level-ID'] ?? 0;
  const levelId = userData?.['Level-ID'] ?? 0;
  
  // ตรวจสอบและ validate levelId
  const validLevelId = (typeof levelId === 'number' && levelId >= 0 && levelId < VIDEO_LIST.length) ? levelId : 0;
  const videoId = VIDEO_LIST[validLevelId];
  
  
  // สร้างอ้างอิงสำหรับไฟล์เสียงต่างๆ
  const correctAudioRef = useRef(new Audio(correctSound)); // เสียงเมื่อตอบถูก
  const wrongAudioRef = useRef(new Audio(wrongSound)); // เสียงเมื่อตอบผิด
  const countdownAudioRef = useRef(null); // เสียงนับถอยหลัง

  // ฟังก์ชันเล่นเสียงนับถอยหลังตามระดับ
  const playCountdownSound = useCallback(() => {
    if (levelId <= 40) {
      countdownAudioRef.current = new Audio(countdownSound1); // เสียงสำหรับระดับต่ำ
    } else if (levelId <= 80) {
      countdownAudioRef.current = new Audio(countdownSound2); // เสียงสำหรับระดับกลาง
    } else {
      countdownAudioRef.current = new Audio(countdownSound3); // เสียงสำหรับระดับสูง
    }
    
    if (countdownAudioRef.current) {
      countdownAudioRef.current.loop = true; // เล่นวนไปเรื่อยๆ
      countdownAudioRef.current.play().catch(e => console.error("Failed to play countdown sound:", e));
    }
  }, [levelId]);

  // ฟังก์ชันหยุดเสียงนับถอยหลัง
  const stopCountdownSound = useCallback(() => {
    if (countdownAudioRef.current) {
      countdownAudioRef.current.pause(); // หยุดเล่น
      countdownAudioRef.current.currentTime = 0; // รีเซ็ตเวลา
    }
  }, []);

  // ฟังก์ชันอัปเดตระดับและคะแนนของผู้ใช้
  const updateUserLevelAndScore = useCallback(async (scoreToAdd) => {
    if (!userData?.username) {
      return;
    }

    try {
      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);

      // อ่านข้อมูลปัจจุบันจากฐานข้อมูล
      let currentDbLevel = userData.level || 0; // ระดับปัจจุบัน
      let currentDbScore = userData.score || 0; // คะแนนปัจจุบัน
      let currentBonus = userData.bonus || false; // สถานะโบนัส
      let currentShowSilver = userData['show-silver'] || 0; // จำนวนครั้งที่แสดง Silver
      let currentShowGold = userData['show-gold'] || 0; // จำนวนครั้งที่แสดง Gold
      let currentShowDiamond = userData['show-diamond'] || 0; // จำนวนครั้งที่แสดง Diamond
      let currentSilverMax = userData['Silver-Max'] || 0; // ค่าสูงสุด Silver
      let currentGoldMax = userData['Gold-Max'] || 0; // ค่าสูงสุด Gold
      let currentDiamondMax = userData['Diamond-Max'] || 0; // ค่าสูงสุด Diamond

      if (docSnap.exists()) {
        const dbData = docSnap.data();
        currentDbLevel = dbData.level || 0;
        currentDbScore = dbData.score || 0;
        currentBonus = dbData.bonus || false;
        currentShowSilver = dbData['show-silver'] || 0;
        currentShowGold = dbData['show-gold'] || 0;
        currentShowDiamond = dbData['show-diamond'] || 0;
        currentSilverMax = dbData['Silver-Max'] || 0;
        currentGoldMax = dbData['Gold-Max'] || 0;
        currentDiamondMax = dbData['Diamond-Max'] || 0;
      }

      // คำนวณค่าต่างๆ สำหรับการอัปเดต
      let newLevel = currentDbLevel;
      const newScore = currentDbScore + scoreToAdd;
      let newShowSilver = currentShowSilver;
      let newShowGold = currentShowGold;
      let newShowDiamond = currentShowDiamond;

      // เพิ่มระดับเมื่อตอบถูกและยังไม่ถึงระดับสูงสุด
      if (scoreToAdd > 0 && currentDbLevel < VIDEO_LIST.length - 1) {
        newLevel = currentDbLevel + 1;
      }

      // อัปเดตจำนวนครั้งที่แสดงตามระดับเมื่อตอบถูก
      if (scoreToAdd > 0) {
        if (currentState === 1) {
          newShowSilver = currentShowSilver + 1; // เพิ่มจำนวนครั้ง Silver
        } else if (currentState === 2) {
          newShowGold = currentShowGold + 1; // เพิ่มจำนวนครั้ง Gold
        } else if (currentState === 3) {
          newShowDiamond = currentShowDiamond + 1; // เพิ่มจำนวนครั้ง Diamond
        }
      }

      // บันทึกข้อมูลที่อัปเดตลงฐานข้อมูล
      await setDoc(userRef, { 
        level: newLevel, 
        score: newScore,
        'show-silver': newShowSilver,
        'show-gold': newShowGold,
        'show-diamond': newShowDiamond
      }, { merge: true });
      
      // ตรวจสอบว่าผลรวมของ Show-Silver + Show-Gold + Show-Diamond เท่ากับ 50 หรือไม่
      // และตรวจสอบว่าผลรวมของ Silver-Max + Gold-Max + Diamond-Max มีค่าน้อยกว่า 150
      const totalShow = newShowSilver + newShowGold + newShowDiamond;
      const totalMax = currentSilverMax + currentGoldMax + currentDiamondMax;
      
      if (totalShow === 50 && totalMax < 150) {
        
        try {
          // 1. ให้นำค่า 50 ไปไว้ที่ Diamond-Max
          // 2. ให้นำค่า 50 ไปไว้ที่ Gold-Max  
          // 3. ให้นำค่า 50 ไปไว้ที่ Silver-Max
          // 4. ให้ลบข้อมูลที่ Silver-Remain ให้หมด
          // 5. ให้ลบข้อมูลที่ Gold-Remain ให้หมด
          // 6. ให้ลบข้อมูลที่ Diamond-Remain ให้หมด
          // 7. ให้ลบข้อมูลที่ Level-Temp ให้หมด
          // 8. ให้นำค่า 50 ไปไว้ที่ Level-ID
          await updateDoc(userRef, {
            'Diamond-Max': 50,
            'Gold-Max': 50,
            'Silver-Max': 50,
            'Silver-Remain': [],
            'Gold-Remain': [],
            'Diamond-Remain': [],
            'Level-Temp': [],
            'Level-ID': 50
          });
          
        } catch (error) {
          console.error("Error performing special updates for total show count 50:", error);
        }
      } else {
        // ตรวจสอบเงื่อนไขตาม current-state และ Max ที่เฉพาะเจาะจง
        try {
          const userRef = doc(db, "Competition-Training", userData.username);
          const docSnap = await getDoc(userRef);
          
          if (docSnap.exists()) {
            const data = docSnap.data();
            const currentState = data['current-state'] || 1;
            const silverMax = data['Silver-Max'] || 0;
            const goldMax = data['Gold-Max'] || 0;
            const diamondMax = data['Diamond-Max'] || 0;
            
            // เงื่อนไขที่ 1: current-state = 1 และ Silver-Max = 50 และผลรวม Show-* < 50
            if (currentState === 1 && silverMax === 50 && totalShow < 50) {
              // สุ่มหมายเลข 0-49
              const randomLevelId = Math.floor(Math.random() * 50); // สุ่ม 0-49
              
              // อัปเดต Level-ID ด้วยหมายเลขสุ่ม
              await updateDoc(userRef, {
                'Level-ID': randomLevelId
              });
            }
            // เงื่อนไขที่ 2: current-state = 2 และ Gold-Max = 50 และผลรวม Show-* < 50
            else if (currentState === 2 && goldMax === 50 && totalShow < 50) {
              // สุ่มหมายเลข 0-49
              const randomLevelId = Math.floor(Math.random() * 50); // สุ่ม 0-49
              
              // อัปเดต Level-ID ด้วยหมายเลขสุ่ม
              await updateDoc(userRef, {
                'Level-ID': randomLevelId
              });
            }
            // เงื่อนไขที่ 3: current-state = 3 และ Diamond-Max = 50 และผลรวม Show-* < 50
            else if (currentState === 3 && diamondMax === 50 && totalShow < 50) {
              // สุ่มหมายเลข 0-49
              const randomLevelId = Math.floor(Math.random() * 50); // สุ่ม 0-49
              
              // อัปเดต Level-ID ด้วยหมายเลขสุ่ม
              await updateDoc(userRef, {
                'Level-ID': randomLevelId
              });
            }
            // เงื่อนไขที่ 4: current-state = 1 และ Silver-Max >= 200 และผลรวม Show-* < 200
            else if (currentState === 1 && silverMax >= 200 && totalShow < 200) {
              // สุ่มหมายเลข 51-199
              const randomLevelId = Math.floor(Math.random() * 149) + 51; // สุ่ม 51-199
              
              // อัปเดต Level-ID ด้วยหมายเลขสุ่ม
              await updateDoc(userRef, {
                'Level-ID': randomLevelId
              });
            }
            // เงื่อนไขที่ 5: current-state = 2 และ Gold-Max >= 200 และผลรวม Show-* < 200
            else if (currentState === 2 && goldMax >= 200 && totalShow < 200) {
              // สุ่มหมายเลข 51-199
              const randomLevelId = Math.floor(Math.random() * 149) + 51; // สุ่ม 51-199
              
              // อัปเดต Level-ID ด้วยหมายเลขสุ่ม
              await updateDoc(userRef, {
                'Level-ID': randomLevelId
              });
            }
            // เงื่อนไขที่ 6: current-state = 3 และ Diamond-Max >= 200 และผลรวม Show-* < 200
            else if (currentState === 3 && diamondMax >= 200 && totalShow < 200) {
              // สุ่มหมายเลข 51-199
              const randomLevelId = Math.floor(Math.random() * 149) + 51; // สุ่ม 51-199
              
              // อัปเดต Level-ID ด้วยหมายเลขสุ่ม
              await updateDoc(userRef, {
                'Level-ID': randomLevelId
              });
            }
          }
        } catch (error) {
          console.error("Error checking Max fields and updating Level-ID:", error);
        }
      }
      
      // ตรวจสอบและรัน SlotGame หลังจากอัปเดตคะแนนเรียบร้อยแล้ว
      await checkAndRunSlotGame(newShowSilver, newShowGold, newShowDiamond);
      
      // อัปเดตข้อมูลผู้ใช้ในคอมโพเนนต์หลัก
      onUserUpdate(userData.username);
    } catch (error) {
      console.error("Error updating user data in Firestore:", error);
      Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถอัปเดตข้อมูลผู้ใช้ได้', 'error');
    }
  }, [userData, onUserUpdate, currentState]);

  // ฟังก์ชันตรวจสอบและรัน SlotGame
  const checkAndRunSlotGame = useCallback(async (showSilver, showGold, showDiamond) => {
    if (!userData?.username) return;
    
    try {
      const totalShow = showSilver + showGold + showDiamond;
      const bonusTriggerValues = [3, 11, 21, 29, 39, 47, 54, 63, 73, 83, 93, 103, 113, 123, 133, 143, 153, 163, 173, 183, 193];
      
      // ตรวจสอบว่าผลรวมอยู่ในรายการตัวเลขที่กำหนดหรือไม่
      if (bonusTriggerValues.includes(totalShow)) {
        // ตรวจสอบค่า Bonus-Slot ปัจจุบัน
        const userRef = doc(db, "Competition-Training", userData.username);
        const docSnap = await getDoc(userRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          const currentBonusSlot = data['Bonus-Slot'];
          
          // ถ้า Bonus-Slot มีค่าเท่ากับ totalShow แล้ว จะไม่รัน SlotGame
          if (currentBonusSlot === totalShow) {
            return;
          }
        }
        
        // บันทึกค่า totalShow ไปยัง Bonus-Slot ก่อน
        try {
          await updateDoc(userRef, {
            'Bonus-Slot': totalShow
          });
        } catch (error) {
          console.error("Error updating Bonus-Slot:", error);
        }
        
        // ใช้วิธีอื่นแทนการสร้าง modal โดยตรง
        // ส่งสัญญาณไปยัง Exercies component ให้แสดง SlotGameModal
        localStorage.setItem('triggerSlotGame', 'true');
        
        // สร้าง custom event เพื่อแจ้งให้ Exercies component รู้
        const event = new CustomEvent('triggerSlotGame', {
          detail: { userData, onUserUpdate }
        });
        window.dispatchEvent(event);
      }
    } catch (error) {
      console.error("Error checking bonus trigger:", error);
    }
  }, [userData]);

  // ฟังก์ชันอัปเดต Level-Meter และ Time-Accu
  const updateLevelMeter = useCallback(async (isCorrect, timeRemaining = 0) => {
    if (!userData?.username) {
      return;
    }

    // ตรวจสอบว่าได้อัปเดต Level-Meter ไปแล้วหรือยัง
    if (levelMeterUpdatedRef.current) {
      return;
    }

    try {
      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        // อ่านข้อมูลปัจจุบันจากฐานข้อมูล
        let currentLevelMeter = data['Level-Meter'] || 1; // ระดับมิเตอร์ปัจจุบัน
        let currentTimeAccu = data['Time-Accu'] || 0; // เวลาสะสมปัจจุบัน
        let currentState = data['current-state'] || 1; // ระดับปัจจุบัน
        let wasLevelMeterReset = false; // สถานะการรีเซ็ตมิเตอร์

        // จัดการ Level-Meter (เพิ่มทีละ 1 จนถึง 5 แล้วรีเซ็ต)
        if (currentLevelMeter < 5) {
          // ถ้าค่าน้อยกว่า 5 ให้เพิ่ม 1
          await updateDoc(userRef, {
            'Level-Meter': currentLevelMeter + 1
          });
        } else {
          // ถ้าค่าเท่ากับ 5 ให้รีเซ็ตเป็น 1
          await updateDoc(userRef, {
            'Level-Meter': 1
          });
          wasLevelMeterReset = true; // บันทึกว่า Level-Meter ถูกรีเซ็ต
        }
        
        // ตั้งค่า flag เป็น true เพื่อป้องกันการอัปเดตซ้ำซ้อน
        levelMeterUpdatedRef.current = true;

        // เพิ่มเวลาที่เหลือไปยัง Time-Accu เมื่อตอบถูก
        if (isCorrect && timeRemaining > 0) {
          await updateDoc(userRef, {
            'Time-Accu': currentTimeAccu + timeRemaining
          });
          currentTimeAccu += timeRemaining; // อัปเดตค่า currentTimeAccu สำหรับการคำนวณต่อไป
        }

        // อัปเดต *-Max เมื่อ Level-Meter ยังไม่ reset
        if (!wasLevelMeterReset) {
          const currentLevelId = data['Level-ID'] || 0;
          
          if (currentState === 1) {
            // Silver State
            const currentSilverMax = data['Silver-Max'] || 0;
            if (currentSilverMax <= currentLevelId && currentSilverMax < 200) {
              await updateDoc(userRef, {
                'Silver-Max': currentSilverMax + 1
              });
            }
          } else if (currentState === 2) {
            // Gold State
            const currentGoldMax = data['Gold-Max'] || 0;
            if (currentGoldMax <= currentLevelId && currentGoldMax < 200) {
              await updateDoc(userRef, {
                'Gold-Max': currentGoldMax + 1
              });
            }
          } else if (currentState === 3) {
            // Diamond State
            const currentDiamondMax = data['Diamond-Max'] || 0;
            if (currentDiamondMax <= currentLevelId && currentDiamondMax < 200) {
              await updateDoc(userRef, {
                'Diamond-Max': currentDiamondMax + 1
              });
            }
          }
        }

        // จัดการการเปลี่ยนระดับเมื่อ Level-Meter รีเซ็ต (เปลี่ยนจาก 5 เป็น 1)
        if (wasLevelMeterReset) {
          const timeAccuPercentage = (currentTimeAccu / 50) * 100; // คำนวณเปอร์เซ็นต์เวลาสะสม
          
          // เงื่อนไขที่ 1: ค่าตั้งแต่ 0 - 35% (ปรับระดับลง)
          if (timeAccuPercentage >= 0 && timeAccuPercentage <= 35) {
            if (currentState === 3) {
              
              // จัดการ Level-Temp และ Diamond-Remain เมื่อปรับระดับลงจาก Diamond
              const currentLevelTemp = data['Level-Temp'] || [];
              const currentDiamondMax = data['Diamond-Max'] || 0;
              const currentGoldMax = data['Gold-Max'] || 0;
              
              // 1. อัปเดต Diamond-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentDiamondMax < 200) {
                await updateDoc(userRef, {
                  'Diamond-Max': currentDiamondMax + 1
                });
              }
              
              // 2. อัปเดต Gold-Max เพิ่ม 5 (ถ้าน้อยกว่า 200)
              if (currentGoldMax < 200) {
                await updateDoc(userRef, {
                  'Gold-Max': currentGoldMax + 5
                });
              }
              
              // 3. ย้ายข้อมูลจาก Level-Temp ไป Diamond-Remain
              await updateDoc(userRef, {
                'Diamond-Remain': [...currentLevelTemp],
                'Level-Temp': []
              });
              
              // 4. เปลี่ยน current-state เป็น 2
              await updateDoc(userRef, {
                'current-state': 2
              });
              
              // 5. อัปเดต Level-ID จาก Gold-Max
              await updateDoc(userRef, {
                'Level-ID': currentGoldMax + 5
              });
              
              // 6. รีเซ็ต Time-Accu และเซ็ท State-Show
              await updateDoc(userRef, {
                'Time-Accu': 0,
                'State-Show': true
              });
              
            } else if (currentState === 2) {
              
              // จัดการ Level-Temp และ Gold-Remain เมื่อปรับระดับลงจาก Gold
              const currentLevelTemp = data['Level-Temp'] || [];
              const currentGoldMax = data['Gold-Max'] || 0;
              const currentSilverMax = data['Silver-Max'] || 0;
              
              // 1. อัปเดต Gold-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentGoldMax < 200) {
                await updateDoc(userRef, {
                  'Gold-Max': currentGoldMax + 1
                });
              }
              
              // 2. อัปเดต Silver-Max เพิ่ม 5 (ถ้าน้อยกว่า 200)
              if (currentSilverMax < 200) {
                await updateDoc(userRef, {
                  'Silver-Max': currentSilverMax + 5
                });
              }
              
              // 3. ย้ายข้อมูลจาก Level-Temp ไป Gold-Remain
              await updateDoc(userRef, {
                'Gold-Remain': [...currentLevelTemp],
                'Level-Temp': []
              });
              
              // 4. เปลี่ยน current-state เป็น 1
              await updateDoc(userRef, {
                'current-state': 1
              });
              
              // 5. อัปเดต Level-ID จาก Silver-Max
              await updateDoc(userRef, {
                'Level-ID': currentSilverMax + 5
              });
              
              // 6. รีเซ็ต Time-Accu และเซ็ท State-Show
              await updateDoc(userRef, {
                'Time-Accu': 0,
                'State-Show': true
              });
              
            } else if (currentState === 1) {
              
              // จัดการ Level-Temp และ Silver-Remain เมื่อคงระดับที่ Silver
              const currentLevelTemp = data['Level-Temp'] || [];
              const currentSilverMax = data['Silver-Max'] || 0;
              const currentSilverRemain = data['Silver-Remain'] || [];
              
              // 1. อัปเดต Silver-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentSilverMax < 200) {
                await updateDoc(userRef, {
                  'Silver-Max': currentSilverMax + 1
                });
              }
              
              // 2. ย้ายข้อมูลจาก Level-Temp ไป Silver-Remain
              const newSilverRemain = [...currentLevelTemp];
              await updateDoc(userRef, {
                'Silver-Remain': newSilverRemain,
                'Level-Temp': []
              });
              
              // 3. ตรวจสอบและอัปเดต Level-ID
              let newLevelId;
              if (!newSilverRemain || newSilverRemain.length === 0) {
                // ถ้าไม่มีข้อมูลใน Silver-Remain ให้ใช้ Silver-Max
                newLevelId = currentSilverMax + 1;
              } else {
                // ถ้ามีข้อมูลใน Silver-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
                newLevelId = newSilverRemain[0];
                // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Silver-Remain
                const updatedSilverRemain = [...newSilverRemain];
                updatedSilverRemain.splice(0, 1);
                await updateDoc(userRef, {
                  'Silver-Remain': updatedSilverRemain
                });
              }
              
              await updateDoc(userRef, {
                'Level-ID': newLevelId
              });
              
              // 4. รีเซ็ต Time-Accu
              await updateDoc(userRef, {
                'Time-Accu': 0
              });
            }
          }
          // เงื่อนไขที่ 2: ค่าตั้งแต่ 36 - 70% (คงระดับเดิม)
          else if (timeAccuPercentage >= 36 && timeAccuPercentage <= 70) {
            
            if (currentState === 1) {
              // Silver (1) → Silver (1)
              const currentSilverMax = data['Silver-Max'] || 0;
              const currentSilverRemain = data['Silver-Remain'] || [];
              
              // 1. อัปเดต Silver-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentSilverMax < 200) {
                await updateDoc(userRef, {
                  'Silver-Max': currentSilverMax + 1
                });
              }
              
              // 2. ตรวจสอบและอัปเดต Level-ID
              let newLevelId;
              if (!currentSilverRemain || currentSilverRemain.length === 0) {
                // ถ้าไม่มีข้อมูลใน Silver-Remain ให้ใช้ Silver-Max
                newLevelId = currentSilverMax + 1;
              } else {
                // ถ้ามีข้อมูลใน Silver-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
                newLevelId = currentSilverRemain[0];
                // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Silver-Remain
                const updatedSilverRemain = [...currentSilverRemain];
                updatedSilverRemain.splice(0, 1);
                await updateDoc(userRef, {
                  'Silver-Remain': updatedSilverRemain
                });
              }
              
              await updateDoc(userRef, {
                'Level-ID': newLevelId
              });
              
              // 3. รีเซ็ต Time-Accu
              await updateDoc(userRef, {
                'Time-Accu': 0
              });
              
            } else if (currentState === 2) {
              // Gold (2) → Gold (2)
              const currentGoldMax = data['Gold-Max'] || 0;
              const currentGoldRemain = data['Gold-Remain'] || [];
              
              // 1. อัปเดต Gold-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentGoldMax < 200) {
                await updateDoc(userRef, {
                  'Gold-Max': currentGoldMax + 1
                });
              }
              
              // 2. ตรวจสอบและอัปเดต Level-ID
              let newLevelId;
              if (!currentGoldRemain || currentGoldRemain.length === 0) {
                // ถ้าไม่มีข้อมูลใน Gold-Remain ให้ใช้ Gold-Max
                newLevelId = currentGoldMax + 1;
              } else {
                // ถ้ามีข้อมูลใน Gold-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
                newLevelId = currentGoldRemain[0];
                // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Gold-Remain
                const updatedGoldRemain = [...currentGoldRemain];
                updatedGoldRemain.splice(0, 1);
                await updateDoc(userRef, {
                  'Gold-Remain': updatedGoldRemain
                });
              }
              
              await updateDoc(userRef, {
                'Level-ID': newLevelId
              });
              
              // 3. รีเซ็ต Time-Accu
              await updateDoc(userRef, {
                'Time-Accu': 0
              });
              
            } else if (currentState === 3) {
              // Diamond (3) → Diamond (3)
              const currentDiamondMax = data['Diamond-Max'] || 0;
              const currentDiamondRemain = data['Diamond-Remain'] || [];
              
              // 1. อัปเดต Diamond-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentDiamondMax < 200) {
                await updateDoc(userRef, {
                  'Diamond-Max': currentDiamondMax + 1
                });
              }
              
              // 2. ตรวจสอบและอัปเดต Level-ID
              let newLevelId;
              if (!currentDiamondRemain || currentDiamondRemain.length === 0) {
                // ถ้าไม่มีข้อมูลใน Diamond-Remain ให้ใช้ Diamond-Max
                newLevelId = currentDiamondMax + 1;
              } else {
                // ถ้ามีข้อมูลใน Diamond-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
                newLevelId = currentDiamondRemain[0];
                // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Diamond-Remain
                const updatedDiamondRemain = [...currentDiamondRemain];
                updatedDiamondRemain.splice(0, 1);
                await updateDoc(userRef, {
                  'Diamond-Remain': updatedDiamondRemain
                });
              }
              
              await updateDoc(userRef, {
                'Level-ID': newLevelId
              });
              
              // 3. รีเซ็ต Time-Accu
              await updateDoc(userRef, {
                'Time-Accu': 0
              });
            }
            
          }
          // เงื่อนไขที่ 3: ค่ามากกว่า 70% (ปรับระดับขึ้น)
          else if (timeAccuPercentage > 70) {
            if (currentState === 1) {
              // Silver (1) → Gold (2)
              
              const currentSilverMax = data['Silver-Max'] || 0;
              const currentGoldRemain = data['Gold-Remain'] || [];
              const currentGoldMax = data['Gold-Max'] || 0;
              
              // 1. อัปเดต Silver-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentSilverMax < 200) {
                await updateDoc(userRef, {
                  'Silver-Max': currentSilverMax + 1
                });
              }
              
              // 2. ล้าง Level-Temp และ Silver-Remain
              await updateDoc(userRef, {
                'Level-Temp': [],
                'Silver-Remain': []
              });
              
              // 3. เปลี่ยน current-state เป็น 2
              await updateDoc(userRef, {
                'current-state': 2
              });
              
              // 4. เซ็ท State-Show เป็น True
              await updateDoc(userRef, {
                'State-Show': true
              });
              
              // 5. ตรวจสอบและอัปเดต Level-ID
              let newLevelId;
              if (!currentGoldRemain || currentGoldRemain.length === 0) {
                // ถ้าไม่มีข้อมูลใน Gold-Remain ให้ใช้ Gold-Max
                newLevelId = currentGoldMax;
              } else {
                // ถ้ามีข้อมูลใน Gold-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
                newLevelId = currentGoldRemain[0];
                // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Gold-Remain
                const updatedGoldRemain = [...currentGoldRemain];
                updatedGoldRemain.splice(0, 1);
                await updateDoc(userRef, {
                  'Gold-Remain': updatedGoldRemain
                });
              }
              
              await updateDoc(userRef, {
                'Level-ID': newLevelId
              });
              
              // 6. รีเซ็ต Time-Accu
              await updateDoc(userRef, {
                'Time-Accu': 0
              });
              
            } else if (currentState === 2) {
              // Gold (2) → Diamond (3)
              
              const currentGoldMax = data['Gold-Max'] || 0;
              const currentDiamondRemain = data['Diamond-Remain'] || [];
              const currentDiamondMax = data['Diamond-Max'] || 0;
              
              // 1. อัปเดต Gold-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentGoldMax < 200) {
                await updateDoc(userRef, {
                  'Gold-Max': currentGoldMax + 1
                });
              }
              
              // 2. ล้าง Level-Temp
              await updateDoc(userRef, {
                'Level-Temp': []
              });
              
              // 3. เปลี่ยน current-state เป็น 3
              await updateDoc(userRef, {
                'current-state': 3
              });
              
              // 4. เซ็ท State-Show เป็น True
              await updateDoc(userRef, {
                'State-Show': true
              });
              
              // 5. ตรวจสอบและอัปเดต Level-ID
              let newLevelId;
              if (!currentDiamondRemain || currentDiamondRemain.length === 0) {
                // ถ้าไม่มีข้อมูลใน Diamond-Remain ให้ใช้ Diamond-Max
                newLevelId = currentDiamondMax;
              } else {
                // ถ้ามีข้อมูลใน Diamond-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
                newLevelId = currentDiamondRemain[0];
                // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Diamond-Remain
                const updatedDiamondRemain = [...currentDiamondRemain];
                updatedDiamondRemain.splice(0, 1);
                await updateDoc(userRef, {
                  'Diamond-Remain': updatedDiamondRemain
                });
              }
              
              await updateDoc(userRef, {
                'Level-ID': newLevelId
              });
              
              // 6. รีเซ็ต Time-Accu
              await updateDoc(userRef, {
                'Time-Accu': 0
              });
              
            } else if (currentState === 3) {
              // Diamond (3) → Diamond (3) (คงระดับ)
              
              const currentDiamondMax = data['Diamond-Max'] || 0;
              const currentDiamondRemain = data['Diamond-Remain'] || [];
              
              // 1. อัปเดต Diamond-Max เพิ่ม 1 (ถ้าน้อยกว่า 200)
              if (currentDiamondMax < 200) {
                await updateDoc(userRef, {
                  'Diamond-Max': currentDiamondMax + 1
                });
              }
              
              // 2. ย้ายข้อมูลจาก Level-Temp ไป Diamond-Remain
              const currentLevelTemp = data['Level-Temp'] || [];
              const newDiamondRemain = [...currentLevelTemp];
              await updateDoc(userRef, {
                'Diamond-Remain': newDiamondRemain,
                'Level-Temp': []
              });
              
              // 3. ตรวจสอบและอัปเดต Level-ID
              let newLevelId;
              if (!newDiamondRemain || newDiamondRemain.length === 0) {
                // ถ้าไม่มีข้อมูลใน Diamond-Remain ให้ใช้ Diamond-Max
                newLevelId = currentDiamondMax + 1;
              } else {
                // ถ้ามีข้อมูลใน Diamond-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
                newLevelId = newDiamondRemain[0];
                // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Diamond-Remain
                const updatedDiamondRemain = [...newDiamondRemain];
                updatedDiamondRemain.splice(0, 1);
                await updateDoc(userRef, {
                  'Diamond-Remain': updatedDiamondRemain
                });
              }
              
              await updateDoc(userRef, {
                'Level-ID': newLevelId
              });
              
              // 4. รีเซ็ต Time-Accu
              await updateDoc(userRef, {
                'Time-Accu': 0
              });
            }
          }
        }
      } else {
        // ถ้าไม่มีข้อมูลผู้ใช้ ให้สร้างใหม่
        const newData = {
          'Level-Meter': 1
        };
        
        // ถ้าตอบถูก ให้เพิ่ม Time-Accu ด้วย
        if (isCorrect && timeRemaining > 0) {
          newData['Time-Accu'] = timeRemaining;
        } else {
          newData['Time-Accu'] = 0;
        }
        
        await setDoc(userRef, newData, { merge: true });
      }
    } catch (error) {
      console.error("Error updating Level-Meter and Time-Accu:", error);
    }
  }, [userData?.username]);

  // ฟังก์ชันอัปเดตฟิลด์ Level-ID ตามเงื่อนไขที่กำหนด
  const updateLevelId = useCallback(async (currentStateValue, userData, updatedArrays = null) => {
    
    if (!userData?.username) {
      console.warn("No username provided for Level-ID update");
      return;
    }

    try {
      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        let newLevelId = 0;
        let updateData = { 'Level-ID': 0 };




        // เงื่อนไขที่ 1: current-state = 1 (Silver)
        if (currentStateValue === 1) {
          // ใช้ข้อมูลที่อัปเดตแล้วถ้ามี หรือใช้ข้อมูลจากฐานข้อมูล
          const silverRemain = updatedArrays?.silverRemain || data['Silver-Remain'];
          const silverMax = updatedArrays?.silverMax || data['Silver-Max'] || 0;
          
          
          if (!silverRemain || silverRemain.length === 0) {
            // ถ้าไม่มีข้อมูลใน Silver-Remain ให้ใช้ค่า Silver-Max
            newLevelId = silverMax;
          } else {
            // ถ้ามีข้อมูลใน Silver-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
            newLevelId = silverRemain[0] || 0;
            // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Silver-Remain array โดยใช้ splice
            const updatedSilverRemain = [...silverRemain]; // สร้าง copy ของ array
            updatedSilverRemain.splice(0, 1); // ลบข้อมูลตำแหน่งที่ 0 เท่านั้น
            updateData['Silver-Remain'] = updatedSilverRemain;
          }
        }
        // เงื่อนไขที่ 2: current-state = 2 (Gold)
        else if (currentStateValue === 2) {
          // ใช้ข้อมูลที่อัปเดตแล้วถ้ามี หรือใช้ข้อมูลจากฐานข้อมูล
          const goldRemain = updatedArrays?.goldRemain || data['Gold-Remain'];
          const goldMax = updatedArrays?.goldMax || data['Gold-Max'] || 0;
          
          
          if (!goldRemain || goldRemain.length === 0) {
            // ถ้าไม่มีข้อมูลใน Gold-Remain ให้ใช้ค่า Gold-Max
            newLevelId = goldMax;
          } else {
            // ถ้ามีข้อมูลใน Gold-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
            newLevelId = goldRemain[0] || 0;
            // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Gold-Remain array โดยใช้ splice
            const updatedGoldRemain = [...goldRemain]; // สร้าง copy ของ array
            updatedGoldRemain.splice(0, 1); // ลบข้อมูลตำแหน่งที่ 0 เท่านั้น
            updateData['Gold-Remain'] = updatedGoldRemain;
          }
        }
        // เงื่อนไขที่ 3: current-state = 3 (Diamond)
        else if (currentStateValue === 3) {
          // ใช้ข้อมูลที่อัปเดตแล้วถ้ามี หรือใช้ข้อมูลจากฐานข้อมูล
          const diamondRemain = updatedArrays?.diamondRemain || data['Diamond-Remain'];
          const diamondMax = updatedArrays?.diamondMax || data['Diamond-Max'] || 0;
          
          
          if (!diamondRemain || diamondRemain.length === 0) {
            // ถ้าไม่มีข้อมูลใน Diamond-Remain ให้ใช้ค่า Diamond-Max
            newLevelId = diamondMax;
          } else {
            // ถ้ามีข้อมูลใน Diamond-Remain ให้ใช้ข้อมูลตำแหน่งที่ 0
            newLevelId = diamondRemain[0] || 0;
            // ลบข้อมูลตำแหน่งที่ 0 ออกจาก Diamond-Remain array โดยใช้ splice
            const updatedDiamondRemain = [...diamondRemain]; // สร้าง copy ของ array
            updatedDiamondRemain.splice(0, 1); // ลบข้อมูลตำแหน่งที่ 0 เท่านั้น
            updateData['Diamond-Remain'] = updatedDiamondRemain;
          }
        }

        // อัปเดตฟิลด์ Level-ID และ array ที่เกี่ยวข้องในฐานข้อมูล
        // แก้ไข: อนุญาตให้ newLevelId = 0 ได้ (สำหรับ state ใหม่ที่ยังไม่มีข้อมูล)
        updateData['Level-ID'] = newLevelId;
        
        // ตรวจสอบว่ามีข้อมูล array ที่จะอัปเดตหรือไม่
        const hasArrayUpdates = Object.keys(updateData).some(key => 
          key !== 'Level-ID' && (key === 'Silver-Remain' || key === 'Gold-Remain' || key === 'Diamond-Remain')
        );
        
        if (hasArrayUpdates) {
          await updateDoc(userRef, updateData);
        } else {
          // ถ้าไม่มี array updates ให้อัปเดตเฉพาะ Level-ID
          await updateDoc(userRef, { 'Level-ID': newLevelId });
        }
        
      } else {
        console.warn("User document not found for Level-ID update");
      }
    } catch (error) {
      console.error("Error updating Level-ID:", error);
    }
  }, [userData?.username]);

  // ฟังก์ชันอัปเดตฟิลด์ *-Max ตาม current-state
  const updateMaxFields = useCallback(async (stateToUse = null) => {
    if (!userData?.username) {
      return;
    }

    try {
      // ใช้ document ID ที่เป็นตัวเล็ก (เช่นเดียวกับใน App.js และ Exercies.js)
      const normalizedUsername = userData.username.toLowerCase();
      const userRef = doc(db, "Competition-Training", normalizedUsername);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        // ใช้ state ที่ส่งเข้ามา หรืออ่านจากฐานข้อมูล
        const currentState = stateToUse || data['current-state'] || 1;
        const currentLevelId = data['Level-ID'] || 0;
        
        
        // อัปเดตฟิลด์ตาม current-state
        if (currentState === 1) {
          // เมื่อ current-state = 1 ให้ตรวจสอบ Silver-Max
          const currentSilverMax = data['Silver-Max'] || 0;
          // เพิ่มค่า Silver-Max +1 เมื่อ Silver-Max <= Level-ID และ Silver-Max < 200
          if (currentSilverMax <= currentLevelId && currentSilverMax < 200) {
            await updateDoc(userRef, {
              'Silver-Max': currentSilverMax + 1
            });
          }
        } else if (currentState === 2) {
          // เมื่อ current-state = 2 ให้ตรวจสอบ Gold-Max
          const currentGoldMax = data['Gold-Max'] || 0;
          // เพิ่มค่า Gold-Max +1 เมื่อ Gold-Max <= Level-ID และ Gold-Max < 200
          if (currentGoldMax <= currentLevelId && currentGoldMax < 200) {
            await updateDoc(userRef, {
              'Gold-Max': currentGoldMax + 1
            });
          }
        } else if (currentState === 3) {
          // เมื่อ current-state = 3 ให้ตรวจสอบ Diamond-Max
          const currentDiamondMax = data['Diamond-Max'] || 0;
          // เพิ่มค่า Diamond-Max +1 เมื่อ Diamond-Max <= Level-ID และ Diamond-Max < 200
          if (currentDiamondMax <= currentLevelId && currentDiamondMax < 200) {
            await updateDoc(userRef, {
              'Diamond-Max': currentDiamondMax + 1
            });
          }
        }
      }
    } catch (error) {
      console.error("Error updating Max fields:", error);
    }
  }, [userData?.username]);

  // ฟังก์ชันเก็บค่า Level-ID ใน Level-Temp เมื่อตอบผิดหรือหมดเวลา
  const updateLevelTemp = useCallback(async () => {
    if (!userData?.username) {
      return;
    }

    // ตรวจสอบว่าได้อัปเดต Level-Temp ไปแล้วหรือยัง
    if (levelTempUpdatedRef.current) {
      return;
    }

    try {
      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const currentLevelId = data['Level-ID'] || 0;
        const currentLevelTemp = data['Level-Temp'] || [];
        
        // เพิ่มค่า Level-ID ปัจจุบันเข้าไปใน Level-Temp array
        const updatedLevelTemp = [...currentLevelTemp, currentLevelId];
        
        await updateDoc(userRef, {
          'Level-Temp': updatedLevelTemp
        });
        
        // ตั้งค่า flag เป็น true เพื่อป้องกันการอัปเดตซ้ำซ้อน
        levelTempUpdatedRef.current = true;
        
      } else {
        // ถ้าไม่มีข้อมูลผู้ใช้ ให้สร้างใหม่พร้อม Level-Temp
        const userRef = doc(db, "Competition-Training", userData.username);
        const currentLevelId = levelId || 0;
        await setDoc(userRef, { 
          'Level-Temp': [currentLevelId] 
        }, { merge: true });
        
        // ตั้งค่า flag เป็น true เพื่อป้องกันการอัปเดตซ้ำซ้อน
        levelTempUpdatedRef.current = true;
        
      }
    } catch (error) {
      console.error("Error updating Level-Temp:", error);
    }
  }, [userData?.username, levelId]);

  // ฟังก์ชันตรวจสอบคำตอบของผู้ใช้
  const checkAnswer = useCallback(async (userAnswer, timeTaken, duration) => {
    stopCountdownSound(); // หยุดเสียงนับถอยหลัง

    // รีเซ็ต flag เมื่อเริ่มตรวจสอบคำตอบใหม่
    levelTempUpdatedRef.current = false;

    const correct = CORRECT_ANSWERS[levelId] === userAnswer; // ตรวจสอบคำตอบ
    let scoreEarned = 0; // คะแนนที่จะได้
    let message = ''; // ข้อความที่จะแสดง
    let icon = ''; // ไอคอนที่จะแสดง
    let timeRemaining = 0; // เวลาที่เหลือ

    if (correct) {
      const timeRemainingSecondsAtSubmit = (duration * 1000 - timeTaken) / 1000;
      scoreEarned = calculateScoreBasedOnTime(timeRemainingSecondsAtSubmit, duration, currentState); 
      timeRemaining = timeRemainingSecondsAtSubmit; // เวลาที่เหลือเมื่อตอบถูก
      
 /*     if (scoreEarned === 3) {
        message = 'ยอดเยี่ยม! คุณตอบถูกและเร็วมาก';
      } else if (scoreEarned === 2) {
        message = 'ดีมาก! คุณตอบถูก';
      } else if (scoreEarned === 1) {
        message = 'ถูกต้อง! แต่ยังช้าไปหน่อย';
      } else {
          message = 'ถูกต้อง! แต่หมดเวลาพอดี จึงไม่ได้คะแนน';
          scoreEarned = 0;
      } */
      message = `ตอบถูก! คุณได้ ${scoreEarned} คะแนน`;

      correctAudioRef.current.play();
      icon = 'success';
    } else {
      scoreEarned = 0;
      message = `ตอบผิด! ลองใหม่อีกครั้ง`;
      wrongAudioRef.current.play();
      icon = 'error';
      
      // เก็บค่า Level-ID ใน Level-Temp เมื่อตอบผิด
      await updateLevelTemp();
    }

    
    // อัปเดต Level-Meter และ Time-Accu (ถ้าตอบถูก)
    await updateLevelMeter(correct, timeRemaining);

    // อ่าน current-state ล่าสุดจากฐานข้อมูลหลังจาก updateLevelMeter
    let latestCurrentState = currentState;
    try {
      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        latestCurrentState = data['current-state'] || currentState;
      }
    } catch (error) {
      console.warn("Failed to get latest current-state, using component state:", error);
    }

    // ตรวจสอบว่ามีการเปลี่ยน state หรือไม่
    if (latestCurrentState !== currentState) {
      // ถ้ามีการเปลี่ยน state ให้ updateLevelMeter จัดการทุกอย่างแล้ว
    } else {
      // อัปเดตฟิลด์ Level-ID ตามเงื่อนไขที่กำหนด
      await updateLevelId(latestCurrentState, userData, {});
    }

    await Swal.fire({
      icon: icon,
      title: correct ? 'ถูกต้อง!' : 'ลองใหม่!',
      text: message,
      confirmButtonText: 'ตกลง'
    });

    await updateUserLevelAndScore(scoreEarned);
    navigate('/exercies');
  }, [levelId, navigate, stopCountdownSound, updateUserLevelAndScore, currentState, updateLevelMeter, updateLevelId, updateMaxFields]);

  // ฟังก์ชันแสดงฟอร์มคำถาม
  const showAnswerForm = useCallback(() => {
    try {
      stopCountdownSound(); // หยุดเสียงนับถอยหลัง
      
      // รีเซ็ต flag เมื่อเริ่มแสดงฟอร์มคำถามใหม่
      levelTempUpdatedRef.current = false;

      // ล้าง timer ทั้งหมด
      if (videoTimerRef.current) {
        clearTimeout(videoTimerRef.current);
      }

      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }

      // หยุดวิดีโอ
      if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
        try {
          playerRef.current.pauseVideo();
        } catch (error) {
          console.warn('Failed to pause video:', error);
        }
      } else {
        console.warn('Player not ready or pauseVideo method not available');
      }
    } catch (error) {
      console.warn('Error in showAnswerForm:', error);
    }

    let timerDuration = 10; // ตั้งเวลาให้เป็น 10 วินาทีเท่ากันหมดทุกระดับ

    let timer = timerDuration; // เวลาที่เหลือ
    let currentPossibleScore = calculateScoreBasedOnTime(timer, timerDuration, currentState); // คะแนนที่อาจได้

    playCountdownSound(); // เริ่มเล่นเสียงนับถอยหลัง

    Swal.fire({
      title: 'ตอบคำถาม',
      html: `
        เหลือเวลา: <strong id="swal-countdown-timer" class="swal-big-text">${timer}</strong> วินาที<br>
        คะแนนที่จะได้: <span id="swal-possible-score" class="swal-big-text">${currentPossibleScore}</span> คะแนน<br>
        <input id="swal-input" class="swal2-input" placeholder="คำตอบของคุณ..." 
               type="number" inputmode="numeric" pattern="[0-9]*">
      `,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: false,
      confirmButtonText: 'ส่งคำตอบ',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      timer: timerDuration * 1000, // ตั้งค่า timer ให้ปิดอัตโนมัติ
      timerProgressBar: true, // แสดง progress bar
      timerProgressBarColor: '#ff0000', // สีแดงเมื่อหมดเวลา
      
      didRender: () => {
        // ตั้งค่าข้อความเมื่อหมดเวลา
        const timerElement = document.querySelector('.swal2-timer-progress-bar');
        if (timerElement) {
          timerElement.setAttribute('title', 'หมดเวลา!');
        }
      },
      
      didOpen: () => {
        const input = Swal.getPopup().querySelector('#swal-input');
        input.focus();
        const timerTextElement = Swal.getPopup().querySelector('#swal-countdown-timer');
        const possibleScoreElement = Swal.getPopup().querySelector('#swal-possible-score');
        
        input.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            Swal.clickConfirm();
          }
        });

        timerIntervalRef.current = setInterval(async () => {
          timer--;
          if (timerTextElement) { 
              timerTextElement.textContent = timer;
          }
          
          currentPossibleScore = calculateScoreBasedOnTime(timer, timerDuration, currentState);
          if (possibleScoreElement) {
              possibleScoreElement.textContent = currentPossibleScore;
          }

          // เมื่อหมดเวลา ปิดกล่องและนำทางไปหน้า exercies
          if (timer <= 0) {
            clearInterval(timerIntervalRef.current);
            stopCountdownSound();
            
            // เล่นเสียงผิดเมื่อหมดเวลา
            wrongAudioRef.current.play();
            
            // หยุดวิดีโอก่อนแสดง popup
            if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
              try {
                playerRef.current.pauseVideo();
              } catch (error) {
                console.warn('Failed to pause video:', error);
              }
            }
            
            // 1. เก็บค่า Level-ID ใน Level-Temp เมื่อหมดเวลา
            updateLevelTemp();
            
            // 2. อัปเดต Level-Meter และ Time-Accu (เหมือนตอบผิด)
            await updateLevelMeter(false, 0);
            
            // 3. อ่าน current-state ล่าสุดจากฐานข้อมูลหลังจาก updateLevelMeter
            let latestCurrentState = currentState;
            try {
              const userRef = doc(db, "Competition-Training", userData.username);
              const docSnap = await getDoc(userRef);
              if (docSnap.exists()) {
                const data = docSnap.data();
                latestCurrentState = data['current-state'] || currentState;
              }
            } catch (error) {
              console.warn("Failed to get latest current-state, using component state:", error);
            }
            
            // 4. อัปเดตคะแนน (ไม่ได้คะแนนเพราะหมดเวลา)
            updateUserLevelAndScore(0);
            
            // ปิดกล่อง SweetAlert2 และแสดงข้อความแจ้งเตือนเมื่อหมดเวลา
            Swal.close();
            setTimeout(() => {
              Swal.fire({
                icon: 'error',
                title: 'ลองใหม่!',
                text: 'ตอบผิด! ลองใหม่อีกครั้ง',
                confirmButtonText: 'ตกลง',
              }).then(async () => {
                // อัปเดตฟิลด์ Level-ID หลังจากปิด popup แล้ว
                await updateLevelId(latestCurrentState, userData, {});
                navigate('/exercies');
              });
            }, 100);
          }
        }, 1000);
      },
      preConfirm: () => {
        const answer = Swal.getPopup().querySelector('#swal-input').value;
        const timeRemaining = timer * 1000;
        const timeTaken = (timerDuration * 1000) - timeRemaining;
        return { 
          answer: answer, 
          timeTaken: timeTaken,
          duration: timerDuration
        };
      },
      willClose: async () => {
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }
        stopCountdownSound();
        
        // ตรวจสอบว่าปิดเพราะหมดเวลาหรือไม่
        if (timer <= 0) {
          // เล่นเสียงผิดเมื่อหมดเวลา
          wrongAudioRef.current.play();
          
          // หยุดวิดีโอก่อนแสดง popup
          if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
            try {
              playerRef.current.pauseVideo();
            } catch (error) {
              console.warn('Failed to pause video:', error);
            }
          }
          
          // 1. เก็บค่า Level-ID ใน Level-Temp เมื่อหมดเวลา
          updateLevelTemp();
          
          // 2. อัปเดต Level-Meter และ Time-Accu (เหมือนตอบผิด)
          await updateLevelMeter(false, 0);
          
          // 3. อ่าน current-state ล่าสุดจากฐานข้อมูลหลังจาก updateLevelMeter
          let latestCurrentState = currentState;
          try {
            const userRef = doc(db, "Competition-Training", userData.username);
            const docSnap = await getDoc(userRef);
            if (docSnap.exists()) {
              const data = docSnap.data();
              latestCurrentState = data['current-state'] || currentState;
            }
          } catch (error) {
            console.warn("Failed to get latest current-state, using component state:", error);
          }
          
          // 4. อัปเดตคะแนน (ไม่ได้คะแนนเพราะหมดเวลา)
          updateUserLevelAndScore(0);
          
          // แสดงข้อความแจ้งเตือนเมื่อหมดเวลา
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'ลองใหม่!',
              text: 'ตอบผิด! ลองใหม่อีกครั้ง',
              confirmButtonText: 'ตกลง',
            }).then(async () => {
              // อัปเดตฟิลด์ Level-ID หลังจากปิด popup แล้ว
              await updateLevelId(latestCurrentState, userData, {});
              navigate('/exercies');
            });
          }, 100);
        }
      }
    }).then(async (result) => {
      // ตรวจสอบว่าปิดเพราะหมดเวลาหรือไม่
      if (result.dismiss === Swal.DismissReason.timer) {
        
        // เล่นเสียงผิดเมื่อหมดเวลา
        wrongAudioRef.current.play();
        
        // หยุดวิดีโอก่อนแสดง popup
        if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
          try {
            playerRef.current.pauseVideo();
          } catch (error) {
            console.warn('Failed to pause video:', error);
          }
        }
        
        // 1. เก็บค่า Level-ID ใน Level-Temp เมื่อหมดเวลา
        updateLevelTemp();
        
        // 2. อัปเดต Level-Meter และ Time-Accu (เหมือนตอบผิด)
        await updateLevelMeter(false, 0);
        
        // 3. อ่าน current-state ล่าสุดจากฐานข้อมูลหลังจาก updateLevelMeter
        let latestCurrentState = currentState;
        try {
          const userRef = doc(db, "Competition-Training", userData.username);
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            latestCurrentState = data['current-state'] || currentState;
          }
        } catch (error) {
          console.warn("Failed to get latest current-state, using component state:", error);
        }
        
        // 4. อัปเดตคะแนน (ไม่ได้คะแนนเพราะหมดเวลา)
        updateUserLevelAndScore(0);
        
        // แสดงข้อความแจ้งเตือนเมื่อหมดเวลา
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'ลองใหม่!',
            text: 'ตอบผิด! ลองใหม่อีกครั้ง',
            confirmButtonText: 'ตกลง',
          }).then(async () => {
            // อัปเดตฟิลด์ Level-ID หลังจากปิด popup แล้ว
            await updateLevelId(latestCurrentState, userData, {});
            navigate('/exercies');
          });
        }, 100);
      }
      // ตรวจสอบว่าผู้ใช้ส่งคำตอบ
      else if (result.isConfirmed) {
        checkAnswer(result.value.answer, result.value.timeTaken, result.value.duration);
      }
    });
  }, [checkAnswer, navigate, playCountdownSound, stopCountdownSound, levelId, updateLevelId, updateLevelTemp]);

  // ฟังก์ชันที่เรียกเมื่อ YouTube player พร้อมใช้งาน
  const onPlayerReady = useCallback((event) => {
    try {
      playerRef.current = event.target; // เก็บอ้างอิง player
      
      // รีเซ็ต flag เมื่อเริ่มเล่นวิดีโอใหม่
      levelTempUpdatedRef.current = false;
      levelMeterUpdatedRef.current = false;
      
      // เพิ่ม delay เล็กน้อยเพื่อให้ player พร้อมใช้งาน
      setTimeout(() => {
        if (playerRef.current && typeof playerRef.current.playVideo === 'function') {
          try {
            playerRef.current.playVideo(); // เริ่มเล่นวิดีโอ
          } catch (error) {
            console.warn('Failed to play video:', error);
          }
        } else {
          console.warn('Player not ready or playVideo method not available');
        }
      }, 100);
      
    } catch (error) {
      console.warn('Failed to set player reference:', error);
    }

    // เพิ่มการตรวจสอบ playerRef.current ก่อนตั้ง timer
    if (playerRef.current) {
      // ล้าง timer เก่าก่อน (ถ้ามี)
      if (videoTimerRef.current) {
        clearTimeout(videoTimerRef.current);
        videoTimerRef.current = null;
      }
      
      videoTimerRef.current = setTimeout(async () => {
        if (videoEndedRef.current) {
          return;
        }
        
        // เล่นเสียงผิดเมื่อหมดเวลา
        wrongAudioRef.current.play();
        
        // อัปเดต Level-Meter และ Time-Accu (เหมือนตอบผิด)
        await updateLevelMeter(false, 0);
        
        // เก็บค่า Level-ID ใน Level-Temp เมื่อหมดเวลา
        updateLevelTemp();
        
        // อ่าน current-state ล่าสุดจากฐานข้อมูลหลังจาก updateLevelMeter
        let latestCurrentState = currentState;
        try {
          const userRef = doc(db, "Competition-Training", userData.username);
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            latestCurrentState = data['current-state'] || currentState;
          }
        } catch (error) {
          console.warn("Failed to get latest current-state, using component state:", error);
        }
        
        // อัปเดตคะแนน (ไม่ได้คะแนนเพราะหมดเวลา)
        updateUserLevelAndScore(0);
        
        // แสดงข้อความแจ้งเตือนเมื่อหมดเวลา
        Swal.fire({
          icon: 'error',
          title: 'หมดเวลา!',
          text: 'คุณไม่ได้ตอบคำถามทันเวลา จึงไม่ได้คะแนน',
          confirmButtonText: 'ตกลง',
        }).then(async () => {
          // อัปเดตฟิลด์ Level-ID หลังจากปิด popup แล้ว
          await updateLevelId(latestCurrentState, userData, {});
          navigate('/exercies');
        });
      }, 30000);
    } else {
      console.warn('Player not ready, skipping timer setup');
    }
  }, [navigate, videoEndedRef, currentState, updateLevelMeter, updateUserLevelAndScore, updateLevelId, updateLevelTemp]);

  // ฟังก์ชันที่เรียกเมื่อสถานะของ YouTube player เปลี่ยน
  const onPlayerStateChange = useCallback((event) => {
    try {
      if (event.data === 0) { // วิดีโอจบแล้ว
        videoEndedRef.current = true; // บันทึกสถานะวิดีโอจบ

        // ล้าง timer ทั้งหมด
        if (videoTimerRef.current) {
          clearTimeout(videoTimerRef.current);
          videoTimerRef.current = null;
        }
        
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }
        
        stopCountdownSound(); // หยุดเสียงนับถอยหลัง
        showAnswerForm(); // แสดงฟอร์มคำถาม
      }
    } catch (error) {
      console.warn('Error in onPlayerStateChange:', error);
    }
  }, [showAnswerForm, stopCountdownSound]);

  // useEffect สำหรับการจัดการเมื่อคอมโพเนนต์ถูกโหลดและถอดถอน
  useEffect(() => {
    // รีเซ็ต flag เมื่อคอมโพเนนต์ถูกโหลด
    levelTempUpdatedRef.current = false;
    
    return () => {
      try {
        // ล้าง timer ทั้งหมด
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
        }
        if (videoTimerRef.current) {
          clearTimeout(videoTimerRef.current);
        }
        stopCountdownSound(); // หยุดเสียงนับถอยหลัง
        
        // รีเซ็ต flag เมื่อคอมโพเนนต์ถูกถอดถอน
        levelTempUpdatedRef.current = false;
        levelMeterUpdatedRef.current = false;

        // หยุดและรีเซ็ตไฟล์เสียง
        if (correctAudioRef.current) {
          correctAudioRef.current.pause();
          correctAudioRef.current.currentTime = 0;
        }
        if (wrongAudioRef.current) {
          wrongAudioRef.current.pause();
          wrongAudioRef.current.currentTime = 0;
        }
        
        // ทำลาย YouTube player
        if (playerRef.current && typeof playerRef.current.destroy === 'function') {
          try {
            playerRef.current.destroy();
          } catch (error) {
            console.warn('Failed to destroy player:', error);
          }
          playerRef.current = null;
        } else {
        }
      } catch (error) {
        console.warn('Error in cleanup:', error);
      }
    };
  }, [stopCountdownSound]);

  // ตั้งค่าสำหรับ YouTube player
  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1, // เล่นอัตโนมัติ
      controls: 0, // ซ่อนปุ่มควบคุม
      rel: 0, // ไม่แสดงวิดีโอที่เกี่ยวข้อง
      modestbranding: 1, // แสดงโลโก้ YouTube แบบเรียบง่าย
      fs: 1, // อนุญาตให้เต็มหน้าจอ
    },
  };

  
  // ตรวจสอบว่า videoId ถูกต้องหรือไม่
  if (!videoId || typeof videoId !== 'string' || videoId.trim() === '') {
    return (
      <div className="video-page-container videodisp-page">
        <div className="video-section">
          <div className="youtube-container">
            <div className="error-message">
              <h2>ไม่พบวิดีโอ</h2>
              <p>ไม่สามารถโหลดวิดีโอได้ กรุณาลองใหม่อีกครั้ง</p>
              <p>Level ID: {levelId}, Valid Level ID: {validLevelId}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ส่งคืน JSX สำหรับแสดงวิดีโอ
  return (
    <div className="video-page-container videodisp-page">
      <div className="video-section">
        <div className="youtube-container">
          <YouTube
            key={videoId}
            videoId={videoId}
            opts={opts}
            onReady={onPlayerReady}
            onStateChange={onPlayerStateChange}
            onError={(e) => {
              console.error("YouTube Player Error:", e);
              console.error("Video ID:", videoId);
              console.error("Level ID:", levelId);
              console.error("Valid Level ID:", validLevelId);
            }}
          />
        </div>
      </div>
    </div>
  );
}

// ส่งออกคอมโพเนนต์ VideoDisp
export default VideoDisp;